export const nomina = {
  1: {
    lunes: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    martes: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    miercoles: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    jueves: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    viernes: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    sabado: {
      trabajadores: {
        1: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        2: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        3: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
        4: {
          id: '',
          salarioGenerado: '',
          comision: '',
          sueldoDiario: '',
        },
      },
      producto: '',
      cantidad: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    salarioSemanal: {
      1: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
      2: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
      3: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
      4: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
    },
  },
  2: {
    lunes: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '',
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '',
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '',
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '',
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    martes: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '', 
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    miercoles: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '', 
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    jueves: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '', 
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    viernes: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '', 
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    sabado: {
      trabajadores: {
        5: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        6: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
        7: {
          id: '',
          salarioGenerado: '',
          comision: '',
          comision2: '', 
          brocales: '',
          sueldoDiario: '',
        },
      },
      producto1: '',
      cantidad1: '',
      producto2: '',
      cantidad2: '', 
      brocales: '',
      salarioPDia: '',
      horaSalarioPDia: '',
    },
    salarioSemanal: {
      5: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
      6: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
      7: {
        salarioNeto: 0,
        salarioBruto: 0,
      },
    },
  },
  3: {
    choferes: {},
    ayudantes: {},
  },
  4: {},
  5: {},
  6: {},
  descripcion: '',
  status: '',
  initialDate: '',
  finalDate: '',
}
